import { get } from 'lodash'

import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, services, sizes } from '@/utils'

import button from '@/components/button'
import squircle from '@/components/icon/squircle'
import draggable from '@/components/misc/draggable'
import { baseClass } from '@/components/rules/utils'
import replacementsFrom from '@/components/services/providers/replacements/form'

function renderRemoveButton(h, index) {
  return h(
    button,
    {
      class: { 'hover-child': this.viewport.breakpoint.mdUp },
      props: {
        icon: 'remove',
        mode: buttonModes.flat,
        color: Colors.error
      },
      on: {
        click: () => {
          this.remove(index)
        }
      }
    }
  )
}

function renderValueRow(h, data, path) {
  const value = get(data, path)
  if (value) {
    return h(
      'div',
      {
        class: 'text-overflow caption'
      },
      `${value}`
    )
  }
}

function renderRules(h, rules) {
  if (Array.isArray(rules) && rules.length) {
    return h(
      'div',
      {
        class: 'faic text--grey small'
      },
      [
        h('div', { class: 'mr-1' }, this.getTranslate(`${services.providers}.hints.replacements.rules`)),
        h('div', { class: '' }, rules.map(rule => {
          return this.getTranslate(`${baseClass}.tags.${rule.tag}`).toLowerCase()
        }).join(', '))
      ]
    )
  }
}

function renderValue(h, { rules, replacement }) {
  return h(
    'div',
    {
      class: 'grid grid-gap--0',
      style: { 'grid-template-columns': '100%' }
    },
    [
      renderValueRow.call(this, h, replacement, 'payload.sender'),
      renderValueRow.call(this, h, replacement, 'payload.text'),
      renderRules.call(this, h, rules)
    ]
  )
}

function renderItem(h, item, index) {
  return h(
    'div',
    {
      class: 'faic grid grid-gap--8 hover-parent hover-parent--opacity',
      style: { 'grid-template-columns': '24px 1fr 36px' }
    },
    [
      h(
        'g-icon',
        {
          class: 'drag_handle',
          props: {
            value: 'drag_handle',
            color: 'grey'
          }
        }
      ),

      h(
        'div',
        {
          class: 'faic hover-background cursor--pointer br--16 py-2 px-3',
          on: {
            click: () => {
              this.edit(index)
            }
          }
        },
        [ renderValue.call(this, h, item) ]
      ),

      renderRemoveButton.call(this, h, index)
    ]
  )
}

function renderItems(h) {
  if (Array.isArray(this.proxy) && this.proxy.length) {
    return h(
      draggable,
      {
        class: 'grid grid-cols--1 grid-gap--8',
        props: {
          value: this.proxy,
          handle: 'drag_handle'
        },
        scopedSlots: {
          item: (item, index) => {
            return renderItem.call(this, h, item, index)
          }
        },
        on: {
          input: event => {
            this.proxy = event
          }
        }
      }
    )
  } else {
    return h(
      'div',
      {
        class: 'grid grid-gap--8 faic',
        style: { 'grid-template-columns': 'auto 1fr' }
      },
      [
        h(
          squircle,
          {
            props: {
              icon: 'search_off',
              color: Colors.grey,
              size: sizes.medium
            }
          }
        ),

        h(
          'div',
          {
            class: 'grid grid-gap--2 ff'
          },
          [
            h('div', {}, this.getTranslate(`${services.providers}.titles.replacements.notFound`)),
            h('div', { class: 'small text--grey' }, this.getTranslate(`${services.providers}.hints.replacements.notFound`))
          ]
        )
      ]
    )
  }
}

function renderDialogBody(h) {
  return h(
    'div',
    {
      class: 'pt-2 px-2'
    },
    [
      h(
        replacementsFrom,
        {
          props: {
            value: this.payload
          },
          on: {
            input: event => {
              this.payload = event
            },
            validation: event => {
              this.disabled = event
            }
          }
        }
      )
    ]
  )
}
function renderDialogFooter(h) {
  let submitLabel = 'misc.buttons.add'
  if (this.editMode) {
    submitLabel = 'misc.buttons.update'
  }

  return h(
    'div',
    {
      class: 'dialog__footer',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            mode: buttonModes.flat,
            label: this.getTranslate('misc.buttons.cancel')
          },
          on: {
            click: () => {
              this.cancel()
            }
          }
        }
      ),
      h(
        button,
        {
          props: {
            mode: buttonModes.flat,
            color: Colors.primary,
            disabled: this.disabled,
            label: this.getTranslate(submitLabel)
          },
          on: {
            click: () => {
              if (this.editMode) {
                this.update()
              } else {
                this.add()
              }
            }
          }
        }
      )
    ]
  )
}
function renderDialog(h) {
  let dialogTitleKey = 'providers.titles.replacements.add'
  if (this.editMode) {
    dialogTitleKey = 'providers.titles.replacements.edit'
  }

  return h(
    components.dialog,
    {
      props: {
        title: this.getTranslate(dialogTitleKey),
        value: this.showDialog,
        maxWidth: 400
      },
      on: {
        input: event => {
          if (event === false) {
            this.cancel()
          }
          this.showDialog = event
        }
      }
    },
    [
      renderDialogBody.call(this, h),
      renderDialogFooter.call(this, h)
    ]
  )
}

function renderAddButton(h) {
  return h(
    'div',
    {
      class: 'fjcfe'
    },
    [
      h(
        button,
        {
          props: {
            icon: icons.add,
            mode: buttonModes.flat,
            color: Colors.primary,
            label: this.getTranslate(`${services.providers}.buttons.add.replacement`)
          },
          on: {
            click: () => {
              this.showDialog = true
            }
          },
          scopedSlots: {
            dialog: () => {
              return renderDialog.call(this, h)
            }
          }
        }
      )
    ]
  )
}

export default function(h) {
  return h(
    components.card,
    {
      class: 'grid pt-3 px-2 pb-2',
      props: {
        title: this.getTranslate(`${services.providers}.hints.replacements.hint`),
        dashed: true,
        outline: true,
        rounded: true
      }
    },
    [
      renderItems.call(this, h),
      renderAddButton.call(this, h)
    ]
  )
}
